import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";

import { AssignedCreativesList } from "../AssignedCreatives/AssignedCreativesList";

export default function AssignedCreativesDialog({
  open,
  setOpen,
  placementId,
  setCreativePreviewURL,
  setSelectedCreativePreview,
  setPreviewDialogOpen
}) {
  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">Assigned Creatives</DialogTitle>
        <DialogContent>
          <AssignedCreativesList
            placementId={placementId}
            handleCloseDialog={handleCloseDialog}
            setCreativePreviewURL={setCreativePreviewURL}
            setSelectedCreativePreview={setSelectedCreativePreview}
            setPreviewDialogOpen={setPreviewDialogOpen}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" disableElevation>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
